import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import * as React from "react";
import { t } from "../../i18n/util";
import { ICell } from "../../types";
import { Colors } from "../util/Colors";
import { HistoryTableHeaderItem } from "../util/ValueDisplayHelpers";
import { HistoryTableHeaderLabel } from "./HistoryTableHeaderLabel";
import { getHistoryTableHeaderCellStyle } from "./historyTableHeaderStyles";
import { TextDot } from "./Dots";
import { StyledTableCell } from "./StyledTableCell";
import { TableHeaderCell } from "./TableHeaderCell";
import { TableLabel } from "./TableLabel";

type IProps = {
    headerItems?: HistoryTableHeaderItem[];
    rows: ICell[][];
    style?: React.CSSProperties;
    stickyHeader?: boolean;
};

export const HistoryValuesTable = ({ headerItems, rows, style, stickyHeader }: IProps) => (
    <Table
        style={{
            tableLayout: "fixed",
            ...style,
            ...(stickyHeader ? { borderCollapse: "separate", borderSpacing: 0 } : undefined),
        }}
    >
        <colgroup>
            <col style={{ width: "5.7592%" }} />
            <col style={{ width: "15.7068%" }} />
            <col style={{ width: "15.7068%" }} />
            <col style={{ width: "15.7068%" }} />
            <col style={{ width: "15.7068%" }} />
            <col style={{ width: "15.7068%" }} />
            <col style={{ width: "15.7068%", borderLeft: `4px solid ${Colors.GREY_200}` }} />
        </colgroup>
        <TableHead>
            <TableRow>
                {headerItems?.map((headerItem, index) => (
                    <TableHeaderCell
                        key={index}
                        style={getHistoryTableHeaderCellStyle(stickyHeader, {
                            textAlign: "center",
                        })}
                    >
                        <HistoryTableHeaderLabel
                            topLabel={
                                index === headerItems.length - 1 ? t("screen.history.firstValue") : headerItem.topLabel
                            }
                            date={headerItem.date}
                            patientName={headerItem.patientName}
                        />
                    </TableHeaderCell>
                ))}
            </TableRow>
        </TableHead>
        <TableBody>
            {rows.map((row, index) => (
                <TableRow key={index} style={{ minHeight: "48px" }}>
                    {row.map((cell, cellIndex) => (
                        <StyledTableCell
                            key={cellIndex}
                            style={{
                                color: cell.color,
                                borderRight: cellIndex < row.length - 1 ? `1px solid ${Colors.GREY_200}` : undefined,
                                backgroundColor: "unset",
                                verticalAlign: "middle",
                                textAlign: "center",
                                height: "58px",
                                padding: "8px 4px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    minHeight: "32px",
                                }}
                            >
                                {cell.color && <TextDot style={{ backgroundColor: cell.color, marginRight: 6 }} />}
                                {cell.content === undefined ||
                                cell.content === null ||
                                cell.content === "" ||
                                typeof cell.content === "string" ||
                                typeof cell.content === "number" ? (
                                    <TableLabel
                                        style={{
                                            maxWidth: "100%",
                                            minWidth: 0,
                                            fontWeight: "inherit",
                                            color: "inherit",
                                        }}
                                        maxLines={2}
                                    >
                                        {`${
                                            cell.content === undefined || cell.content === null || cell.content === ""
                                                ? "-"
                                                : cell.content
                                        }${
                                            cell.content !== undefined && cell.content !== "" && cell.adornmentText
                                                ? `\u00A0${cell.adornmentText}`
                                                : ""
                                        }`}
                                    </TableLabel>
                                ) : (
                                    cell.content
                                )}
                            </div>
                        </StyledTableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    </Table>
);
